import moment from 'moment-timezone';
import { FORMAT_DATE } from '../../constants/common';
import { CreateOrUpdateTourTrashPayload } from '../../repository/mytm/tour-trash/tourTrashRepository';
import { TourTrashForm, TourTrashType } from '../../types/tourtrash';
import { toDayBySecond, toHourBySecond, toISOString, toSecondByDay, toSecondByHour } from '../helper';

export const toDataFormTourTrash = (record: TourTrashType): TourTrashForm => {
  return {
    tourTrashId: record.id,
    productId: record.product && record.product.id,
    title: record.title,
    description: record.description,
    startDate: moment(moment(record.startDate).format(FORMAT_DATE)),
    startTime: moment(record.startDate),
    endDate: moment(moment(record.endDate).format(FORMAT_DATE)),
    endTime: moment(record.endDate),
    participationLevel:
      record.participationLevel && record.participationLevel !== ''
        ? record.participationLevel.split(',').map(v => Number(v))
        : '0',
    productDescription: record.product && record.product.detail,
    productLegal: record.product && record.product.legal,
    productName: record.product && record.product.name,
    productImagePath: record.product && record.product.images?.map(r => r.imageUrl).join(','),
    productVideoId: record.product && record.product.videoId,
    productVideoType: record.product ? record.product.videoType : 'youtube',
    remindPushNotificationFrequency: record.remindPushNotificationFrequency || 1,
    pushNotificationTo: record.pushNotificationTo,
    sendEmailTo: record.sendEmailTo,
    sendEmailAtLaunch: record.sendEmailAtLaunch,
    pushNotificationAtLaunch: record.pushNotificationAtLaunch,
    timeToPushNotificationBeforeEndDate: toHourBySecond(record.timeToPushNotificationBeforeEndDate),
    timeToSendEmailBeforeEndDate: toHourBySecond(record.timeToSendEmailBeforeEndDate),
    timeToAutoCloseAfterEndDate: toDayBySecond(record.timeToAutoCloseAfterEndDate),
    countries: record?.countries,
  };
};

export const toDataFormEditTourTrashActive = (record: TourTrashType) => {
  return {
    tourTrashId: record.id,
    productId: record.product && record.product.id,
    title: record.title,
    description: record.description,
    productDescription: record.product && record.product.detail,
    productLegal: record.product && record.product.legal,
    productName: record.product && record.product.name,
    startDate: undefined,
    startTime: undefined,
    endDate: undefined,
    endTime: undefined,
    participationLevel: undefined,
    productImagePath: undefined,
    productVideoId: undefined,
    productVideoType: undefined,
    remindPushNotificationFrequency: undefined,
    pushNotificationTo: undefined,
    sendEmailTo: undefined,
    sendEmailAtLaunch: undefined,
    pushNotificationAtLaunch: undefined,
    timeToPushNotificationBeforeEndDate: undefined,
    timeToSendEmailBeforeEndDate: undefined,
    timeToAutoCloseAfterEndDate: undefined,
    countries: record?.countries,
  };
};

export const toPayloadTourTrash = (values: TourTrashForm): CreateOrUpdateTourTrashPayload => {
  return {
    id: values.tourTrashId,
    title: values.title,
    description: values.description,
    startDate: toISOString(values.startDate, values.startTime),
    endDate: toISOString(values.endDate, values.endTime),
    // remindPushNotificationFrequency:
    //   (values.remindPushNotificationFrequency && Number(values.remindPushNotificationFrequency)) || 1,
    sendEmailTo: values.sendEmailTo,
    pushNotificationTo: values.pushNotificationTo,
    // participationLevel:
    //   values.participationLevel && values.participationLevel.length > 0 ? values.participationLevel.join(',') : '0',
    product: {
      id: values.productId,
      name: values.productName || '',
      detail: values.productDescription || '',
      legal: values.productLegal || '',
      images: values?.productImagePath
        ? values?.productImagePath.split(',').map(item => ({ imageUrl: item }))
        : undefined,
      videoType: values.productVideoType,
      videoId: values.productVideoId,
    },
    sendEmailAtLaunch: values.sendEmailAtLaunch,
    pushNotificationAtLaunch: values.pushNotificationAtLaunch,
    timeToSendEmailBeforeEndDate: toSecondByHour(values.timeToSendEmailBeforeEndDate),
    timeToPushNotificationBeforeEndDate: toSecondByHour(values.timeToPushNotificationBeforeEndDate),
    timeToAutoCloseAfterEndDate: toSecondByDay(values.timeToAutoCloseAfterEndDate),
    countries: values?.countries,
    options: values?.options,
  };
};
